import { render, staticRenderFns } from "./About.vue?vue&type=template&id=326634bc&scoped=true&"
import script from "./about.js?vue&type=script&lang=js&"
export * from "./about.js?vue&type=script&lang=js&"
import style0 from "./about.scss?vue&type=style&index=0&id=326634bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326634bc",
  null
  
)

export default component.exports